import { registerServiceWorker } from "./pwa-client.js";

/** Finish the visible page's network/paint work before warming the app shell. */
export function scheduleServiceWorker(): void {
  const register = () => {
    if (typeof requestIdleCallback === "function")
      requestIdleCallback(() => void registerServiceWorker(), {
        timeout: 5000,
      });
    else window.setTimeout(() => void registerServiceWorker(), 1500);
  };
  if (document.readyState === "complete") register();
  else window.addEventListener("load", register, { once: true });
}
